<template>
  <v-row align="start" class="mb-8 flex-nowrap">
    <v-col cols="auto" class="pr-4">
      <svg-icon
        type="mdi"
        :path="icon"
        :size="$vuetify.breakpoint.xsOnly ? '40' : '60'"
        color="#bb1d77"
      ></svg-icon>
    </v-col>
    <v-col>
      <h3 class="text-h5 font-weight-bold mb-2">{{ title }}</h3>
      <p class="text-h6 font-weight-light mb-0">
        <span v-if="text.includes(':link')">
          <span
            v-html="
              text.replace(
                ':link',
                `<a href='/register' class='primary--text font-weight-medium' style='text-decoration: underline;'>${$t('solution_inscription_link')}</a>`,
              )
            "
          ></span>
        </span>
        <span v-else>
          {{ text }}
        </span>
      </p>
    </v-col>
  </v-row>
</template>

<script>
import Vue from "vue";
import SvgIcon from "@jamescoyle/vue-icon";

export default Vue.extend({
  name: "moduleItem",
  components: {
    SvgIcon,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
});
</script>
